import React, { Component, ErrorInfo, ReactNode } from "react";

import "./index.scss";

interface ErrorBoundaryProps {
  children: ReactNode;
  fallback?: ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
}

class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  state: ErrorBoundaryState = { hasError: false };

  static getDerivedStateFromError(): ErrorBoundaryState {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error("ErrorBoundary caught an error", error, errorInfo);
  }

  reset = () => {
    this.setState({ hasError: false });
  };

  render() {
    const { children, fallback } = this.props;
    const { hasError } = this.state;

    if (!hasError) return children;
    if (fallback) return fallback;

    return (
      <div className="error-boundary">
        <div className="error-boundary-message">Something went wrong.</div>
        <button type="button" className="error-boundary-retry" onClick={this.reset}>
          Try again
        </button>
      </div>
    );
  }
}

export default ErrorBoundary;
